import { useTranslation } from 'react-i18next';
import { MdCheck } from 'react-icons/md';
import HeroCard from '../HeroCard';

const ConsentAlreadyDone = () => {
  const [t] = useTranslation('calendar');

  return (
    <HeroCard
      variant="success"
      icon={<MdCheck />}
      title={t('select-context.already-done-title')}
    >
      {t('select-context.already-done-description')}
    </HeroCard>
  );
};

export default ConsentAlreadyDone;
